export const PACKAGE_VERSION = "0.49.0";
